import { useRef } from 'react'

import { MOBILE_MENU_ID } from 'artkive/components/Navbar/MobileMenu/MobileMenu'
import { MAIN_HEADER_ID } from 'artkive/components/Navbar/Navbar'
import useIsomorphicLayoutEffect from 'artkive/hooks/useIsomorphicLayoutEffect'
import muiTheme from 'artkive/utils/muiTheme'

const brandsBannerHeight = muiTheme.constants.brandBanner.mobileHeight
const toolbarHeight = muiTheme.constants.toolbar.mobileHeight

export function useLockBodyScroll(locked) {
  const scrollYRef = useRef(0)
  const documentBodyStylesRef = useRef(null)
  const documentElementStylesRef = useRef(null)
  const mainHeaderElementStylesRef = useRef(null)
  const mobileMenuElementStylesRef = useRef(null)

  useIsomorphicLayoutEffect(() => {
    const mainHeaderElement = document.getElementById(MAIN_HEADER_ID)
    const mobileMenuElement = document.getElementById(MOBILE_MENU_ID)

    if (locked) {
      scrollYRef.current = window.scrollY

      documentBodyStylesRef.current = {
        overflow: document.body.style.overflow,
        width: document.body.style.width,
        position: document.body.style.position,
        top: document.body.style.top,
      }
      documentElementStylesRef.current = {
        overflow: document.documentElement.style.overflow,
      }
      mainHeaderElementStylesRef.current = {
        position: mainHeaderElement.style.position,
        top: mainHeaderElement.style.top,
      }
      mobileMenuElementStylesRef.current = {
        paddingTop: mobileMenuElement.style.paddingTop,
      }

      document.body.style.cssText += `
        overflow: hidden !important;
        width: 100% !important;
        position: fixed !important;
        top: -${scrollYRef.current}px
      `
      document.documentElement.style.cssText += `
        overflow: hidden !important;
      `
      mainHeaderElement.style.position = 'fixed'
      const scrolledOffset = brandsBannerHeight - scrollYRef.current
      mainHeaderElement.style.top = (scrolledOffset > 0 ? scrolledOffset : 0) + 'px'
      mobileMenuElement.style.paddingTop = (
        scrollYRef.current < brandsBannerHeight ?
          (brandsBannerHeight + toolbarHeight) - scrollYRef.current : toolbarHeight
      ) + 'px'
    } else {
      if (documentBodyStylesRef.current) {
        document.body.style.overflow = documentBodyStylesRef.current.overflow
        document.body.style.width = documentBodyStylesRef.current.width
        document.body.style.position = documentBodyStylesRef.current.position
        document.body.style.top = documentBodyStylesRef.current.top
        document.documentElement.style.overflow = documentElementStylesRef.current.overflow
        mainHeaderElement.style.position = mainHeaderElementStylesRef.current.position
        mainHeaderElement.style.top = mainHeaderElementStylesRef.current.top
        mobileMenuElement.style.paddingTop = mobileMenuElementStylesRef.current.paddingTop
        window.scrollTo(0, scrollYRef.current)
      }
    }
  }, [locked])
}
